import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: auto;
  padding: 5rem 0;
`;
export const RelatedPost = styled.div`
  img {
    width: 90%;
    max-width: 90%;
  }
  h3 {
    text-align: center;
    width: 90%;
  }
  h2,
  p {
    width: 90%;
    max-width: 90%;
    text-align: center;
    margin-left: 0;
  }
  a {
    font-weight: 800;
    color: gray;
    text-decoration: none;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }
  .related-img-container {
    max-height: 200px;
    overflow: hidden;
  }
`;
export const RelatedPostContainer = styled.div`
  display: grid;
  grid-template-columns: 33% 33% 33%;
  a {
    text-decoration: none;
    color: black;
  }
`;
